(() => {
  if (window.location.pathname !== '/pages/trade-application') return;

  const appOrigin = 'https://automation-hub-ce5v6rticq-nw.a.run.app';
  const submissionMessage = 'penny-morrison:trade-application-submitted';
  const successPath = '/pages/trade-application-submitted';
  const formFrame = Array.from(document.querySelectorAll('iframe')).find((frame) => {
    try {
      const source = new URL(frame.src, window.location.href);
      return source.origin === appOrigin
        && source.pathname === '/trade-application'
        && source.searchParams.get('embedded') === '1';
    } catch {
      return false;
    }
  });

  if (!formFrame) return;

  let navigating = false;
  window.addEventListener('message', (event) => {
    if (event.origin !== appOrigin || event.source !== formFrame.contentWindow) return;
    if (!event.data || typeof event.data !== 'object') return;
    if (event.data.type !== submissionMessage || Object.keys(event.data).length !== 1) return;
    if (navigating) return;

    navigating = true;
    try {
      window.location.assign(successPath);
    } catch {
      navigating = false;
    }
  });
})();
